<template lang="html">
 <section class="widgets">
  <div class="row">
   <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
                            <p style="position: absolute; color: White; top: 40%; left: 40%;">
                                <img src='../../assets/snakes.gif' /></p>
                        </div>
    <div class="col-md-12 grid-margin">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-0">User List</h4>
            <div class="justify-content-centermy-1 row">
                 <b-form-fieldset horizontal label="Rows per page" class="col-6">
                  <b-form-select :options="[{text:20,value:20},{text:30,value:30},{text:50,value:50}]" v-model="count">
                  </b-form-select>
                </b-form-fieldset>

                <b-form-fieldset horizontal label="Filter" class="col-6">
                  <b-form-input v-model="keyword" placeholder="Type to Search" @keyup.enter="enterClicked"></b-form-input>
                </b-form-fieldset>
              </div>
                <div class="row">
                <div class="col-md-4" style="padding-bottom:15px;" v-for="i in items">  
          <div class="card" style="border: 1px solid rgba(0, 0, 0, 0.125)!important;
    border-radius: 0.25rem!important;">
  <div class="card-body">
    <h5 class="card-title">{{i.name}}</h5>
    <h6 class="card-subtitle mb-2 text-muted"><i v-if="i.is_rescuer">Rescuer</i><i v-else>User</i></h6>
    <p class="card-text">{{i.email}}</p>
    <p class="card-text">{{i.phone}}</p>
    <router-link :to="'/editusers/' + i._id" class="card-link">Edit</router-link>
    <a class="card-link" @click="deleteUser(i._id)" style="float:right;cursor:pointer;color:red;">Delete</a>
  </div>
</div>
  </div>
  </div>
  <div class="row">
               <div class="col-md-12" v-if="pages > 1">
            
      <b-pagination
      v-model="currentPage"
      :total-rows="pages"
      :per-page="count"
      aria-controls="my-table"
      style="float:right;"
    ></b-pagination>
    </div>    
              </div>
        </div>
        </div>
     </div>
    </div>
  </div>
  </section>
 </template>
<script lang="js">
import axios from 'axios'
export default {
  name: 'news',
  data () {
    return {
      items: [],
      fields: [
        {
          key: 'username',
          sortable: true
        },
        {
          key: 'name'
        },
        {
          key: 'phone',
          sortable: true
        },
        {
          key: 'email',
          sortable: true
        },
        {
          key: 'location',
          label: 'Edit'
        },
        {
          key: 'status',
          label: 'Delete'
        }
      ],
      currentPage: 1,
      count: 30,
      pages: '',
      keyword: '',
      striped: true,
      loading: false
    }
  },
  watch: {
    currentPage() {
      this.getList();
    }
  },
  mounted: function () {
    this.getList()
  },
  methods: {
    enterClicked() {
      this.getList();
    },
    getList () {
      this.loading = true
      axios({
        url: 'https://sarpatnapi.leopardtechlabs.in/user/allusers/',
        method: 'GET',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
        params: {
          count: this.count,
          page: this.currentPage,
          keyword: this.keyword,
        },
      }).then(response => {
        this.items = response.data.data
        this.pages = (response.data.pages * this.count)
        console.log(this.pages)
        this.loading = false
      }).catch(e => {
        this.errors.push(e)
      })
    },
    approve: function (item) {
      var vm = this
      vm.item = item.item._id
      axios({
        method: 'POST',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
        url: 'https://sarpatnapi.leopardtechlabs.in/user/activate',
        data: {
          id: vm.item
        }
      }).then(response => {
        alert('User was successfully Approved')
        this.getList()
      }).catch(e => {
      })
    },
    deleteUser: function (item) {
      var vm = this
      vm.item = item
      this.loading = true
      axios({
        method: 'DELETE',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
        url: 'https://sarpatnapi.leopardtechlabs.in/user/delete',
        data: {
          id: vm.item
        }
      }).then(response => {
        alert('Successfully Deleted User')
        this.loading = false
        this.getList()
      }).catch(e => {
        this.loading = false
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/forms/userlist.vue